import {
  Component,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-labdashboard-header',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './ladashboard-header.component.html',
  styleUrls: ['./ladashboard-header.component.scss']
})
export class LabDashboardHeaderComponent implements OnInit {

  @Output()
  logout = new EventEmitter<void>();

  labName = '';

  ngOnInit(): void {

    const doctorStr =
      localStorage.getItem('LAB_DOCTOR');

    if (doctorStr) {

      const doctor = JSON.parse(doctorStr);

      this.labName =
        `${doctor.first_name || ''} ${doctor.last_name || ''}`.trim();
    }
  }

  onLogout(): void {

    this.logout.emit();
  }
}